import React from 'react';
import CheckboxList from './CheckboxList';

interface LanguageCheckboxListProps {
  label: string;
  checkedLanguages: string[];
  onSelectedLanguagesChanged?: (checkedItems: string[]) => void;
  readOnly?: boolean,
  availableLanguages?: string[];
  required?: boolean;
}

const languages = ["DE", "FR", "IT"];

const LanguageCheckboxList: React.FunctionComponent<LanguageCheckboxListProps> = ({ availableLanguages, label, readOnly, onSelectedLanguagesChanged, checkedLanguages, required }) => {
  return (
    <CheckboxList
      required={required}
      label={label}
      readOnly={readOnly}
      availableItems={availableLanguages || languages}
      checkedItems={checkedLanguages}
      onChange={onSelectedLanguagesChanged}
    />
  );
}

LanguageCheckboxList.defaultProps = {
  onSelectedLanguagesChanged: () => { },
  availableLanguages: languages
} as Partial<LanguageCheckboxListProps>;

export default LanguageCheckboxList;
